export default class Alert {
    constructor(el, status, status_name, message, isOnlyHandle = false) {
        if (!this.set(el, status, status_name, message, isOnlyHandle)) return;

        if (!isOnlyHandle) this.init();
    }

    set(el, status, status_name, message, isOnlyHandle) {
        if (!el) return false;
        this.root = el;
        this.closeAlertButton = el.querySelector('.form-alert__close-alert');
        this.alertBar = el.querySelector('.form-alert__bar');
        this.alertWrapperStatus = el.querySelector('.form-alert__status');
        this.alertWrapperMessage = el.querySelector('.form-alert__message');

        this.handleAlertClasses = this.handleAlertClasses.bind(this);

        if (isOnlyHandle) {
            this.handleAlertClasses();
            return true;
        } else {
            if (!status || !status_name || !message) return false;
            this.status = status;
            this.status_name = status_name;
            this.message = message;
            this.handleMouseEnter = this.handleMouseEnter.bind(this);
            this.handleMouseLeave = this.handleMouseLeave.bind(this);
            this.handleData = this.handleData.bind(this);
            this.resizeObserverCallback =
                this.resizeObserverCallback.bind(this);

            return true;
        }
    }

    init() {
        this.handleData();
        this.closeAlertButton.addEventListener(
            'click',
            this.handleAlertClasses
        );
        this.root.addEventListener('mouseenter', this.handleMouseEnter);
        this.root.addEventListener('mouseleave', this.handleMouseLeave);
    }

    handleMouseEnter() {
        const alertWidth = parseFloat(
            getComputedStyle(this.root).getPropertyValue('width')
        );
        const currentBarWidth = parseFloat(
            getComputedStyle(this.alertBar).getPropertyValue('width')
        );
        const percentageValue = (currentBarWidth * 100) / alertWidth;
        this.alertBar.style.transition = 'none';
        this.alertBar.style.width = `${percentageValue}%`;
    }

    handleMouseLeave() {
        const alertWidth = parseFloat(
            getComputedStyle(this.root).getPropertyValue('width')
        );
        const currentBarWidth = parseFloat(
            getComputedStyle(this.alertBar).getPropertyValue('width')
        );
        const percentageValue = (currentBarWidth * 100) / alertWidth;
        const totalSeconds = 4 * 60;
        const transitionValue =
            (totalSeconds - (totalSeconds * percentageValue) / 100) / 60;
        if (this.root.classList.contains('active')) {
            this.alertBar.style.transition = `${transitionValue}s linear`;
            this.alertBar.style.width = '100%';
        }
    }

    handleData() {
        this.root.classList.add(this.status, 'active');
        this.alertWrapperStatus.textContent = this.status_name;

        if (this.status === 'success') {
            const tempDiv = document.createElement('div');
            tempDiv.classList.add('form-alert__success-message-wrapper');
            tempDiv.innerHTML = this.message;
            this.alertWrapperMessage.appendChild(tempDiv);
        } else {
            this.alertWrapperMessage.textContent = this.message;
        }

        new ResizeObserver(this.resizeObserverCallback).observe(this.alertBar);
    }

    resizeObserverCallback(entries) {
        const { contentRect, target } = entries[0];
        const parentElement = target.parentElement;
        const actualElementWidth = contentRect.width;
        const totalElementWidth = parseFloat(
            getComputedStyle(parentElement).getPropertyValue('width')
        );
        if (totalElementWidth - 2 === actualElementWidth) {
            setTimeout(this.handleAlertClasses, 100);
        }
    }

    handleAlertClasses() {
        this.root.classList.remove('active');
        this.alertBar.style.removeProperty('width');
        this.alertBar.style.removeProperty('transition');
        setTimeout(() => {
            this.root.classList.remove('success', 'error');
            this.alertWrapperStatus.textContent = '';
            this.alertWrapperMessage.textContent = '';
        }, 300);
    }
}
